import React from 'react';
import type { TextProps } from '@goodfynd/react-web.ui.text';
import { Text } from '@goodfynd/react-web.ui.text';

export const ReviewText = ({
  children,
  ...props
}: Omit<TextProps, 'children'> & {
  children?: React.ReactNode;
}) => {
  return <Text {...props}>{children}</Text>;
};
